import { createRoot } from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router-dom";

import Layout from "./root";
import Index from "./routes/_index";
import "~/tailwind.css";
import BillingMigrationPage from "./routes/billing-migration";
import ClusterDetails from "./routes/clusters.$clusterId";
import CustomerDetails from "./routes/customers.$customerId";
import FleetOperationsList from "./routes/fleet-ops";
import NamespaceDetails from "./routes/namespaces.$orgId.$region.$namespaceId";
import OrgDetails from "./routes/orgs.$orgId";
import OrgsToPurge from "./routes/orgs.purge";
import SettingsOverridesPage from "./routes/settings-overrides";
import VersionGatesPage from "./routes/version-gates";

// BigInt JSON serialization
// eslint-disable-next-line @typescript-eslint/no-unused-vars
interface BigInt {
  toJSON(): number;
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
(BigInt.prototype as any).toJSON = function () {
  const int = Number.parseInt(this.toString());
  return Number.isNaN(int) ? this.toString() : int;
};

const router = createBrowserRouter([
  {
    path: "/",
    element: <Layout />,
    children: [
      {
        index: true,
        element: <Index />,
      },
      {
        path: "clusters/new",
        element: <div>New Cluster Form</div>,
      },
      {
        path: "clusters/:clusterId",
        element: <ClusterDetails />,
      },
      {
        path: "billing-migration",
        element: <BillingMigrationPage />,
      },
      {
        path: "fleet-ops",
        element: <FleetOperationsList />,
      },
      {
        path: "settings-overrides",
        element: <SettingsOverridesPage />,
      },
      {
        path: "version-gates",
        element: <VersionGatesPage />,
      },
      {
        path: "orgs-purge",
        element: <OrgsToPurge />,
      },
      {
        path: "orgs/:orgId",
        element: <OrgDetails />,
      },
      {
        path: "customers/:customerId",
        element: <CustomerDetails />,
      },
      {
        path: "namespaces/:orgId/:region/:namespaceId",
        element: <NamespaceDetails />,
      },
    ],
  },
]);

const container = document.getElementById("root");
if (!container) {
  throw new Error("No root element found");
}

const root = createRoot(container);
root.render(<RouterProvider router={router} />);
